import {merge} from 'lodash';
import {getAllAppAwareTiers} from '../api/appAwareTiersThunk';

/* eslint-disable no-param-reassign */
const {createSlice} = require('@reduxjs/toolkit');

const initialState = {
    allTiers: [],
    status: {
        loading: false,
        error: false
    },
    error: null
};

const setPendingState = (state) => {
    state.error = null;
    const status = {
        loading: true,
        error: false
    };
    state.status = merge(state.status, status);
};

const setRejectedState = (state, action) => {
    const status = {
        loading: false,
        error: true
    };
    state.status = merge(state.status, status);
    state.error = action.error.message;
};

const setGetFulfilledState = (state) => {
    const status = {
        loading: false,
        error: false
    };
    state.error = null;
    state.status = merge(state.status, status);
};

const appAwareTierSlice = createSlice({
    name: 'appAwareTierSlice',
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllAppAwareTiers.fulfilled, (state, action) => {
                setGetFulfilledState(state);
                state.allTiers = action.payload;
            })
            .addMatcher((action) => action.type.endsWith('/pending') && action.type.includes('appAwareTiers/'), (state) => {
                setPendingState(state);
            })
            .addMatcher((action) => action.type.endsWith('/rejected') && action.type.includes('appAwareTiers/'), (state, action) => {
                setRejectedState(state, action);
            });
    }
});

export default appAwareTierSlice.reducer;
